import api from './api/client';

const loadCheckout = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const el = document.createElement('script');
  el.src = 'https://checkout.razorpay.com/v1/checkout.js';
  el.onload = resolve;
  el.onerror = () => reject(new Error('Payment gateway failed to load. Please refresh and try again.'));
  document.head.appendChild(el);
});

const err = (e) => e.response?.data?.detail || 'Payment could not be started. Please try again.';

// Pays a pending commitment: create the gateway order, open checkout, then confirm with the server.
// The webhook is the source of truth; the confirm call just makes the page update immediately.
export async function payCommitment(commitmentId) {
  let order;
  try {
    order = (await api.post('/api/payments/create-order/', { commitment: commitmentId })).data;
  } catch (e) {
    throw new Error(err(e));
  }
  if (order.provider === 'mock') {
    await api.post('/api/payments/mock-pay/', { order_id: order.order_id });
    return 'paid';
  }
  await loadCheckout();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      order_id: order.order_id,
      amount: order.amount,
      currency: order.currency,
      name: 'FraxLandShare',
      handler: async (resp) => {
        try {
          await api.post('/api/payments/verify/', resp);
          resolve('paid');
        } catch (e) {
          reject(new Error(err(e)));
        }
      },
      modal: { ondismiss: () => resolve('dismissed') },
    });
    rzp.open();
  });
}
